import{createContext}from"react";export const PortalStateContext=createContext(null);export const PortalDispatchContext=createContext(null);